'use strict';
mpangoApp.controller('DashboardController',DashboardController);
function DashboardController($rootScope, $scope,$state,Mvendor ,Muser,Mcontribution ,Mbudget , Mtodo, Mreports, Notification, $filter,$window) {
    $scope.calar = '#91AFD3';
    $scope.calar1 = '#9EB328';
    $scope.calarbc = '#FFBE94';
    $scope.calarbc1 = '#21996B';
    $scope.$on('$viewContentLoaded', function () {
        Mbudget.getItems().success(function(data,status) {
            $scope.items = data.items;
    		var amount = [];
            var saSum = 0;
            var eaSum = 0;
            for (var i = $scope.items.length - 1; i >= 0; i--) {
              if (parseFloat($scope.items[i].s_amount) != 0) {
                saSum += parseFloat($scope.items[i].s_amount);
              };
              if (parseFloat($scope.items[i].e_amount) != 0) {
                eaSum += parseFloat($scope.items[i].e_amount);
              };
            };
            amount.push(saSum);
            amount.push(eaSum);
            $scope.budgetchart = {label:["Estimated","Spent"],series:amount};
    	}).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
        Mcontribution.getContr().success(function  (data,status) {
            $scope.mcontributions = data.contr;
            var amount = [];
            var c_pledge = 0;
            var c_paid = 0;
            for (var i = $scope.mcontributions.length - 1; i >= 0; i--) {
              if (parseFloat($scope.mcontributions[i].c_pledge) != 0) {
                c_pledge += parseFloat($scope.mcontributions[i].c_pledge);
              };
              if (parseFloat($scope.mcontributions[i].c_paid) != 0) {
                c_paid += parseFloat($scope.mcontributions[i].c_paid);
              };
            };
            amount.push(c_pledge);
            amount.push(c_paid);
            $scope.contribchart = {label:["Pledged","Collected"],series:amount};
        });
        
        Muser.getUsers().success(function(data,status) {
            var allUser = data.mallusers|| [''];
            $scope.musers = data.musers|| [''];
            $scope.userInctive = $filter('filter')(allUser, { status: "inactive" });
            var allEvents = data.mevents;
            $scope.events = data.mevents;
            $scope.eventInctive = $filter('filter')(allEvents, { status: "inactive" });
        });
        Mtodo.getTasks().success(function(data,status) {
    		var todoData = data.mtodos
    		$scope.mtodos = $filter('filter')(todoData, { status: "not done" });
    	});
        Mvendor.getVendors().success(function  (data,status) {
            $scope.mvendors = data.mvendors;    
        });
        Mreports.getActlog().success(function(data, status) {
            $scope.actlogs = data;
        });
    });
    $scope.exportDoc = function(tempname,xtype, id) {
        Mreports.toExcel(tempname,xtype,id).success(function  (data,status) {
            var token = $rootScope.sytoken;
            var url = 'index.php/api/toexcel?data='+tempname+'&eId='+id+'&xtype='+xtype+'&token='+token;
            $window.open(url);
        }).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
    };
    $scope.sort = function(keywoo){
        $scope.sortKey = keywoo;   
        $scope.reverse = !$scope.reverse; 
    }
    $scope.currentPage = 1;
    $scope.pageSize = 10;
    $scope.pageChangeHandler = function(num) {};
}
DashboardController.$inject = ['$rootScope', '$scope','$state','Mvendor' ,'Muser','Mcontribution' ,'Mbudget' , 'Mtodo', 'Mreports', 'Notification', '$filter','$window'];